import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNull, isUndefined } from 'lodash';

export function noneZeroValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (isNull(control.value) || isUndefined(control.value) || control.value === '') return null;

    const isValid = +control.value !== 0;
    const message = {
      noneZero: { message: 'The field value can not be 0' },
    };
    return isValid ? null : message;
  };
}
